import { css } from '@emotion/react';
import { Typography, Skeleton } from '@mui/material';
import { Box } from '@mui/system';
import { FC } from 'react';
import { useTranslation } from 'react-i18next';

import { ReactComponent as MinusIcon } from 'src/assets/svg/minus.svg';
import { ReactComponent as PlusIcon } from 'src/assets/svg/plus.svg';

import { Section } from '../../../components/section';
import { getTheme } from '../../../utils/getTheme';

import { styles } from './styles';

const { theme, isHosTheme } = getTheme();

export const BookingDetailsSkeleton: FC = () => {
    const { t } = useTranslation();
    return (
        <Section header={t('booking_summary_booking_details_title')} withHeaderStipe={!isHosTheme}>
            <Box css={css(styles.wrapper())}>
                <Box css={styles.studentNumber}>
                    <Typography variant="h4">
                        {t('booking_summary_booking_details_student_number_subtitle')}
                    </Typography>
                    <Box css={styles.counter}>
                        <Box css={css(styles.iconWrapper, styles.disabledIcon)}>
                            <MinusIcon color={theme.palette.text.disabled} />
                        </Box>
                        <Skeleton variant="text" />
                        <Box css={css(styles.iconWrapper, styles.disabledIcon)}>
                            <PlusIcon color={theme.palette.text.disabled} />
                        </Box>
                    </Box>
                </Box>
                <Box css={styles.bookingLengthWrapper}>
                    <Typography variant="h4">
                        {t('booking_summary_booking_details_length_subtitle')}
                    </Typography>
                    <Box css={styles.bookingLength}>
                        <Skeleton css={styles.skeleton} />
                        <Skeleton css={styles.skeleton} />
                    </Box>
                </Box>
                <Box css={styles.instalmentPlanWrapper}>
                    <Typography variant="h4">
                        {t('booking_summary_booking_details_instalment_plan_subtitle')}
                    </Typography>
                    <Box css={styles.instalmentPlan}>
                        <Skeleton css={styles.skeleton} />
                        <Skeleton css={styles.skeleton} />
                        <Skeleton css={styles.skeleton} />
                    </Box>
                </Box>
            </Box>
        </Section>
    );
};
